export default "__VITE_ASSET__CGYzijNp__"